module.exports = __webpack_public_path__ + "static/img/3.e1e88ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/zh/3.png
// module id = JA7Z
// module chunks = 0